export const menuLinks = [
  {
    name: 'Home',
    url: '/',
  },
  {
    name: 'Services',
    sublinks: [
      {
        name: 'General Medicine',
        url: '/services/general-medicine',
      },
      {
        name: 'Pediatrics',
        url: '/services/pediatrics',
      },
      {
        name: `Women's Health`,
        url: '/services/womens-health',
      },
      {
        name: 'Dermatology',
        url: '/services/dermatology',
      }
    ]
  },
  {
    name: 'About Us',
    sublinks: [
      {
        name: 'Our Story',
        url: '/about/our-story',
      },
      {
        name: 'FAQs',
        url: '/about/faqs',
      },
    ]
  },
  {
    name: 'Our Team',
    url: '/team',
  },
  {
    name: 'Blog',
    url: '/blog',
  },
  {
    name: 'Contact',
    url: '/contact',
  },
]